/**
 * Stat Counter
 */
export default () => {

    class AnimatedPercentageBar {

        constructor(element, percentTextClass) {
            this.element = element;
            this.percentTextClass = percentTextClass;
            this.observer();
            this.init();
        }
    
        init() {
            this.observer.observe(this.element);
        }
    
        observer() {
            this.observerOptions = { root: null, rootMargin: "0px 0px", threshold: 0 };
            this.observer = new IntersectionObserver((elements) => {
                elements.forEach((element) => {
                    if (element.isIntersecting) {
                        const value = parseFloat(element.target.dataset.animateValue);
                        this.increment(element.target, value);
                    }
                });
            }, this.observerOptions);
        }
    
        increment(element, end) {
            const start = 0;
            const duration = 3000;

            const percentTextBlock = [...this.element.getElementsByClassName(this.percentTextClass)][0]
            percentTextBlock.style.color = `transparent`;
    
            let startTimestamp = null;
            const step = (timestamp) => {
                startTimestamp = startTimestamp ? startTimestamp : timestamp;
                const progress = (timestamp - startTimestamp) / duration;
                const easingProgress = Math.min(1 - Math.pow(1 - progress, 3), 1);
                const rawNumber = Math.abs(easingProgress * (end - start) + start);
                element.style.width = rawNumber + '%';
                if (easingProgress < 1) {
                    window.requestAnimationFrame(step);
                } else {
                    percentTextBlock.style.color = `inherit`;
                }
            };
    
            window.requestAnimationFrame(step);
        }
    }

    const dataModules = [...document.getElementsByClassName(`js-stat-percentage-bar__percentage--container`)];
    dataModules.forEach((element) => {
        const shouldAnimate = element.dataset.animateStat;
        if (shouldAnimate === 'true') {
            new AnimatedPercentageBar(element, `stat-percentage-bar__percentage`);
        }
    });
}